import { css } from '@emotion/core'
import { measures } from 'styles/variables'

const { unit } = measures

export const logo = css`
  width: ${4 * unit}px;
`

export const container = css`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
`

export const textContainer = css`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  width: 100%;
`

export const imagePlaceholder = css`
  width: 32px;
`
